import { render, staticRenderFns } from "./impact.vue?vue&type=template&id=79341430&scoped=true"
import script from "./impact.ts?vue&type=script&lang=ts&external"
export * from "./impact.ts?vue&type=script&lang=ts&external"
import style0 from "./impact.scss?vue&type=style&index=0&id=79341430&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79341430",
  null
  
)

export default component.exports